export default from './menu-tab';



// WEBPACK FOOTER //
// ./app/components/menu-tab/index.js